import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManageShiftsTeamListComponent } from './pages/manage-shifts-team-list/manage-shifts-team-list.component';
import { ManageShiftsTeamMembersListComponent } from './pages/manage-shifts-team-members-list/manage-shifts-team-members-list.component';
import { ManageOpenShiftsListComponent } from './pages/manage-open-shifts-list/manage-open-shifts-list.component';
import { ManageShiftPlanningComponent } from './pages/manage-shift-planning/manage-shift-planning.component';
import { ManageShiftsTeamDayListComponent } from './pages/manage-shifts-team-list/manage-shifts-team-day-list/manage-shifts-team-day-list.component';
import { ManageShiftsTeamWeekListComponent } from './pages/manage-shifts-team-list/manage-shifts-team-week-list/manage-shifts-team-week-list.component';
import { ManageShiftsTeamMembersDayListComponent } from './pages/manage-shifts-team-members-list/manage-shifts-team-members-day-list/manage-shifts-team-members-day-list.component';
import { ManageShiftsTeamMembersWeekListComponent } from './pages/manage-shifts-team-members-list/manage-shifts-team-members-week-list/manage-shifts-team-members-week-list.component';
import { ManageShiftsComponent } from './manage-shifts.component';
import { ButtonModule, CalendarModule, CheckboxModule, ConfirmDialogModule, DialogModule, DropdownModule,
  InputSwitchModule, InputTextModule, MultiSelectModule, OverlayPanelModule, PaginatorModule, RadioButtonModule,
  ScrollPanelModule, TabMenuModule, TableModule, ToastModule, TooltipModule } from 'primeng';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PublishOpenShiftComponent } from './components/publish-open-shift-pop-up/publish-open-shift.component';
import { OpenShiftPopComponent } from './components/open-shift-pop-up/open-shift-pop.component';
import { SharedModule } from '../shared/shared.module';
import { ManageShiftSlotCardComponent } from './components/manage-shift-slot-card/manage-shift-slot-card.component';
import { TeamWeeklySlotCardComponent } from './components/team-weekly-slot-card/team-weekly-slot-card.component';
import { TeamDaySlotCardComponent } from './components/team-day-slot-card/team-day-slot-card.component';
import { AddRowDirective } from '../shared/directives/add-row.directive';
import { TeamMemberSlotCardComponent } from './components/team-member-slot-card/team-member-slot-card.component';
import { ManageShiftDetailsComponent } from './components/manage-shift-details/manage-shift-details.component';
import { AddTimeOffModalComponent } from './components/add-time-off-modal/add-time-off-modal.component';
import { MyOpenShiftsComponent } from './pages/my-open-shifts/my-open-shifts.component';
import { MyOpenShiftsSlotCardComponent } from './components/my-open-shifts-slot-card/my-open-shifts-slot-card.component';
import { TeamMemberDaySlotCardComponent } from './components/team-member-day-slot-card/team-member-day-slot-card.component';
import { AddManageShiftPlanningComponent } from './pages/add-manage-shift-planning/add-manage-shift-planning.component';
import { ManageShiftMonthlyCalenderComponent } from './components/manage-shift-monthly-calender/manage-shift-monthly-calender.component';
import { AddDeleteShiftPlanComponent } from './pages/add-delete-shift-plan/add-delete-shift-plan.component';


@NgModule({
  declarations: [
    ManageShiftsComponent,
    ManageShiftsTeamListComponent,
    ManageShiftsTeamMembersListComponent,
    ManageOpenShiftsListComponent,
    ManageShiftPlanningComponent,
    ManageShiftsTeamDayListComponent,
    ManageShiftsTeamWeekListComponent,
    ManageShiftsTeamMembersDayListComponent,
    ManageShiftsTeamMembersWeekListComponent,
    OpenShiftPopComponent,
    PublishOpenShiftComponent,
    ManageShiftSlotCardComponent,
    TeamWeeklySlotCardComponent,
    AddRowDirective,
    TeamMemberSlotCardComponent,
    ManageShiftDetailsComponent,
    TeamDaySlotCardComponent,
    AddRowDirective,
    AddTimeOffModalComponent,
    MyOpenShiftsComponent,
    MyOpenShiftsSlotCardComponent,
    TeamMemberDaySlotCardComponent,
    AddManageShiftPlanningComponent,
    ManageShiftMonthlyCalenderComponent,
    AddDeleteShiftPlanComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    TabMenuModule,
    CheckboxModule,
    TableModule,
    ToastModule,
    CalendarModule,
    SharedModule,
    DropdownModule,
    InputTextModule,
    DialogModule,
    MultiSelectModule,
    RadioButtonModule,
    OverlayPanelModule,
    TooltipModule,
    PaginatorModule,
    ConfirmDialogModule,
    InputSwitchModule,
    ScrollPanelModule
  ],
  exports: [
    ManageShiftMonthlyCalenderComponent,
    MyOpenShiftsComponent
  ]
})
export class ManageShiftsModule { }
